import BossModel from "@/models/BossModel";

export default class SendMailContent extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'dossier/send-mail/content';

    static fields() {
        return {
            id: this.attr(null),
            html: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        }
    }

    /**
     *
     * @param id
     * @returns {Promise<AxiosResponse<T>>}
     */
    static find(id) {
        return this.api().find(id).then((response) => {
            return response.html;
        })
    }
}
